import zhLocale from "element-ui/lib/locale/lang/zh-CN"

export default {
    ...zhLocale,
    "login": {
        "accountPlaceholder": "请输入账号",
        "backSignIn": "返回",
        "confirmPassword": "确认密码",
        "diffPwd": "两次输入密码不一致",
        "email": "邮箱",
        "forgetFormTitle": "重置密码",
        "forgetPassword": "忘记密码?",
        "loginButton": "登录",
        "loginSuccessDesc": "欢迎回来",
        "loginSuccessTitle": "登录成功",
        "mobile": "手机号码",
        "mobilePlaceholder": "请输入手机号码",
        'ChangeOne': '换一个',
        "mobileUsername": "请输入用户名",
        "mobileCompanyname": "请输入企业名称",
        "mobileSignInFormTitle": "手机登录",
        "otherSignIn": "其他登录方式",
        "password": "密码",
        "passwordPlaceholder": "请输入密码",
        "policy": "我同意xxx隐私政策",
        "policyPlaceholder": "勾选后才能注册",
        "qrSignInFormTitle": "二维码登录",
        "registerButton": "免费注册",
        "rememberMe": "记住我",
        "scanSign": "扫码后点击\"确认\"，即可完成登录",
        "signInDesc": "",
        "signInFormTitle": "账号登录",
        "signInTitle": "模型调用-水利模型构建平台",
        "signUpFormTitle": "注册",
        "smsCode": "短信验证码",
        "smsPlaceholder": "请输入验证码",
        "ssoEditDesc": "修改您的个人详细信息开始使用！",
        "ssoInfoDesc": "访问您的个人详细信息开始使用！",
        "ssoSignInFormTitle": "三方授权登录",
        "tenantName": "租户",
        "userName": "账号",
        "serviceHotline": '服务热线',
        "manual": '下载说明手册',
    },
    "info": {
        "basicInfo": "基本资料",
        "resetPwd": "修改密码",
        "title": "基本信息",
        "userSocial": "社交信息"
    },
    "password": {
        "cfPwdMsg": "请输入确认密码",
        "confirmPassword": "确认密码",
        "diffPwd": "两次输入密码不一致",
        "newPassword": "新密码",
        "newPwdMsg": "请输入新密码",
        "oldPassword": "旧密码",
        "oldPwdMsg": "请输入旧密码",
        "pwdRules": "长度在 6 到 20 个字符"
    },
    "rules": {
        "mail": "请输入邮箱地址",
        "nickname": "请输入用户昵称",
        "phone": "请输入正确的手机号码",
        "truemail": "请输入正确的邮箱地址",
        "truephone": "请输入正确的手机号码"
    },
    "user": {
        "createTime": "创建日期",
        "dept": "所属部门",
        "email": "用户邮箱",
        "man": "男",
        "mobile": "手机号码",
        "nickname": "用户昵称",
        "posts": "所属岗位",
        "roles": "所属角色",
        "sex": "性别",
        "title": "个人信息",
        "username": "用户名称",
        "woman": "女",
        "normalText": "获取验证码",
    },
    "home": {
        "CorporateInformation": '企业信息',
        "AccountInformation": '账户信息',
        'BidOrder': '投标订单',
        "dashboard": "首页",
    },
    "companyInfo": {
        "Companyname": '企业名称',
        "Contact": '联系人'
    }
}




// WEBPACK FOOTER //
// ./src/i18n/config/zh.js